import _slicedToArray from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/var/jenkins_home/workspace/tingle.b462fce8-c3fd-4157-817f-5a1715b99180/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import memoize from 'lodash/memoize';
import qs from 'query-string';
import { useRouter } from 'next/router';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { Type } from '@spotify-internal/encore-web';
import { black, screenXsMax, spacer16, spacer8, white, gray50 } from '@spotify-internal/encore-foundation/web';
import { formatText } from '../utils';
import { AssetDebugFrame } from './AssetDebugFrame';
import { makeImageSizeUrl, makeWebpUrl, makeJpgUrl } from '.';
import { EMPTY_IMAGE } from './constants'; // [screen width, image width]

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledImage = styled.img.withConfig({
  displayName: "ContentfulImage__StyledImage",
  componentId: "sc-1hlp3w7-0"
})([""]);
var StyledImageWithPlaceholder = styled(StyledImage).withConfig({
  displayName: "ContentfulImage__StyledImageWithPlaceholder",
  componentId: "sc-1hlp3w7-1"
})(["&.lazyloading{filter:blur(8px);}&.lazyloaded{filter:none;transition:1s cubic-bezier(0.215,0.61,0.355,1);}"]);
var CaptionText = styled(Type.p).attrs({
  variant: Type.body3
}).withConfig({
  displayName: "ContentfulImage__CaptionText",
  componentId: "sc-1hlp3w7-2"
})(["position:absolute;bottom:", ";right:", ";text-align:right;background-color:", ";width:fit-content;padding:0 5px 0 5px;color:", ";@media (max-width:", "){bottom:", ";right:", ";}"], spacer16, spacer16, hexToRgba(black, 0.5), white, screenXsMax, spacer8, spacer8);
export var lightCaptionStyle = {
  position: 'relative',
  color: gray50,
  background: white,
  textAlign: 'center'
};
export var ContentfulImage = function ContentfulImage(props) {
  var _asset$file, _asset$file$contentTy, _asset$file2, _asset$file2$contentT;

  var asset = props.asset,
      caption = props.caption,
      _props$imageStyle = props.imageStyle,
      imageStyle = _props$imageStyle === void 0 ? {} : _props$imageStyle,
      _props$captionStyle = props.captionStyle,
      captionStyle = _props$captionStyle === void 0 ? {} : _props$captionStyle,
      imageComponent = props.imageComponent,
      fit = props.fit,
      focus = props.focus,
      format = props.format,
      _props$lazyLoad = props.lazyLoad,
      lazyLoad = _props$lazyLoad === void 0 ? true : _props$lazyLoad,
      _props$sizes = props.sizes,
      sizes = _props$sizes === void 0 ? [[480, 480], [768, 768], [1280, 1280], [1600, 1600]] : _props$sizes,
      children = props.children,
      _props$allowVideo = props.allowVideo,
      allowVideo = _props$allowVideo === void 0 ? true : _props$allowVideo,
      _props$videoOptions = props.videoOptions,
      videoOptions = _props$videoOptions === void 0 ? {
    autoPlay: true,
    playsInline: true,
    loop: true,
    muted: true
  } : _props$videoOptions,
      constraints = props.constraints;
  var router = useRouter();
  var debug = props.debug || 'debug_assets' in ((router === null || router === void 0 ? void 0 : router.query) || {});
  var pictureRef = React.useRef(null);

  if (allowVideo && asset !== null && asset !== void 0 && (_asset$file = asset.file) !== null && _asset$file !== void 0 && (_asset$file$contentTy = _asset$file.contentType) !== null && _asset$file$contentTy !== void 0 && _asset$file$contentTy.startsWith('video/')) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/media-has-caption
      _jsx("video", _objectSpread(_objectSpread({}, videoOptions), {}, {
        title: asset.description,
        children: /*#__PURE__*/_jsx("source", {
          src: asset.file.url,
          type: asset.file.contentType
        })
      }))
    );
  }

  if ( // !asset?.file?.details?.image?.width ||
  !(asset !== null && asset !== void 0 && (_asset$file2 = asset.file) !== null && _asset$file2 !== void 0 && (_asset$file2$contentT = _asset$file2.contentType) !== null && _asset$file2$contentT !== void 0 && _asset$file2$contentT.startsWith('image/'))) {
    var _asset$file3;

    // eslint-disable-next-line no-console
    console.error('Invalid asset', asset === null || asset === void 0 ? void 0 : asset.title, asset === null || asset === void 0 ? void 0 : (_asset$file3 = asset.file) === null || _asset$file3 === void 0 ? void 0 : _asset$file3.contentType);
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var contentType = asset.file.contentType;

  var _qs$parseUrl = qs.parseUrl(asset.file.url),
      url = _qs$parseUrl.url,
      query = _qs$parseUrl.query;

  var assetWidth = props.assetWidth || asset.file.details.image.width;
  var assetHeight = props.assetHeight || asset.file.details.image.height;
  var description = asset.description;

  if (fit) {
    query.fit = fit;
  }

  if (focus) {
    query.f = focus;
  }

  if (format) {
    query.fm = format[0];

    if (format.length > 1) {
      query.fl = format[1];
    }
  } // only set width and height of the image in the query if they were passed in as explicit
  // parameters, otherwise allow contentful to return the natural values


  if (props.assetWidth) {
    query.w = "".concat(assetWidth);
  }

  if (props.assetHeight) {
    query.h = "".concat(assetHeight);
  }

  var baseImageUrl = "".concat(url, "?").concat(qs.stringify(query));
  var baseWebpImageUrl = makeWebpUrl(baseImageUrl);
  var size = memoize(function (w) {
    return makeImageSizeUrl(baseImageUrl, w, undefined);
  }, function (w) {
    return w;
  });
  var sizeWebp = memoize(function (w) {
    return makeImageSizeUrl(baseWebpImageUrl, w, undefined);
  }, function (w) {
    return w;
  });
  var _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? true : _props$placeholder;

  if (placeholder === true) {
    placeholder = makeImageSizeUrl(makeJpgUrl(baseImageUrl, undefined, 0), 12, 10);
  }

  var ImageComponent = imageComponent || (placeholder ? StyledImageWithPlaceholder : StyledImage);

  var fallbackSrcSet = _toConsumableArray(sizes).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        q = _ref2[0],
        w = _ref2[1];

    return "".concat(size(w), " ").concat(q, "w");
  }).join(', ');

  var getMediaQuery = function getMediaQuery(ms) {
    var i = sizes.indexOf(ms) - 1;
    var min = i < 0 ? '' : "(min-width: ".concat(sizes[i][0] + 1, "px) and");
    return "".concat(min, " (max-width: ").concat(ms[1], "px)").trim();
  };

  var srcSetProp = lazyLoad ? 'data-srcset' : 'srcSet';

  var makeSource = function makeSource(mediaQuery, ctype, srcSet) {
    return /*#__PURE__*/_jsx("source", _objectSpread({
      media: mediaQuery,
      type: ctype
    }, _defineProperty({}, srcSetProp, srcSet)));
  };

  var pictureContent = /*#__PURE__*/_jsxs(_Fragment, {
    children: [assetWidth && sizes.map(function (ms) {
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [makeSource(getMediaQuery(ms), 'image/webp', "".concat(sizeWebp(ms[1]), " 1x, ").concat(sizeWebp(assetWidth && Math.min(assetWidth, ms[1] * 2)), " 2x")), makeSource(getMediaQuery(ms), contentType, "".concat(size(ms[1]), " 1x, ").concat(size(Math.min(assetWidth, ms[1] * 2)), " 2x"))]
      }, "".concat([ms[0], ms[1]].join('x')));
    }), /*#__PURE__*/_jsx(ImageComponent, _objectSpread(_objectSpread({}, _defineProperty({}, srcSetProp, fallbackSrcSet)), {}, {
      srcSet: lazyLoad ? placeholder || EMPTY_IMAGE : '',
      "data-sizes": "auto",
      alt: description,
      style: _objectSpread({
        display: 'block'
      }, imageStyle),
      className: lazyLoad ? 'lazyload' : ''
    })), caption && /*#__PURE__*/_jsx(CaptionText, {
      style: captionStyle,
      dangerouslySetInnerHTML: {
        __html: formatText(caption)
      }
    })]
  });

  var picture = /*#__PURE__*/_jsxs("picture", {
    ref: pictureRef,
    children: [pictureContent, children]
  });

  var defaultConstraints = allowVideo ? {
    video: {
      required: false
    }
  } : {};
  return debug ? /*#__PURE__*/_jsx(AssetDebugFrame, {
    asset: asset,
    constraints: _objectSpread(_objectSpread({}, defaultConstraints), constraints),
    pictureRef: pictureRef,
    children: picture
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: picture
  });
};